import { EventEmitter, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable, Subject, BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SharedDataService {
    private subject = new Subject<any>();
    private subjectPropositions = new Subject<null>();
    private subjectSoldes = new Subject<any>();
    private subjectSoldesProp = new Subject<any>();
    private subjectSoldesArbitrage = new Subject<any>();
    private subjectSoldesAnalyse = new Subject<any>();
    private subjectArbitrage = new Subject<any>();
    private subjectAnalyse = new Subject<any>();
    private subjectEmbauche = new Subject<any>();
    private subjectDashboard = new Subject<any>();
    private subjectAnnee = new Subject<any>();
    private subjectHistoriqueEIA = new Subject<any>();
    private subjectAffectations = new Subject<any>();
    private subjectMonArbitrage = new Subject<any>();

    constructor() { }


    sendClickEvent() {
        this.subject.next();
    }

    sendRefreshTableHAffectations() {
        this.subjectAffectations.next();
    }

    sendRefreshTableHistoriqueEIA() {
        this.subjectHistoriqueEIA.next();
    }

    sendRefreshTablePropositions() {
        this.subjectPropositions.next();
    }

    sendRefreshTableSoldesArbitrage() {
        this.subjectSoldesArbitrage.next();
    }
    sendRefreshTableSoldesAnalyse() {
        this.subjectSoldesAnalyse.next();
    }
    sendRefreshTableSoldes() {
        this.subjectSoldes.next();
    }
    sendRefreshTableSoldesProp() {
        this.subjectSoldesProp.next();
    }

    sendRefreshTableArbitrage() {
        this.subjectArbitrage.next();
    }

    sendRefreshTableAnalyse() {
        this.subjectAnalyse.next();
      }

      sendRefreshTableEmbauche() {
        this.subjectEmbauche.next();
      }

      sendRefreshDashboard() {
        this.subjectDashboard.next();
      }

      sendRefetchTableMonArbitrage() {
          this.subjectMonArbitrage.next();
      }

    sendRefreshAnnee() {
        this.subjectAnnee.next();
    }

    getClickEvent(): Observable<any> {
        return this.subject.asObservable();
    }

    getClickEventRefreshTableAffectations(): Observable<null> {
        return this.subjectAffectations.asObservable();
    }

    getClickEventRefreshTableHistoriqueEIA(): Observable<null> {
        return this.subjectHistoriqueEIA.asObservable();
    }

    getClickEventRefreshTablePropositions(): Observable<null> {
        return this.subjectPropositions.asObservable();
    }

    getClickEventRefreshTableSoldesArbitrage(): Observable<any> {
        return this.subjectSoldesArbitrage.asObservable();
    }
    getClickEventRefreshTableSoldesAnalyse(): Observable<any> {
        return this.subjectSoldesAnalyse.asObservable();
    }
    getClickEventRefreshTableSoldes(): Observable<any> {
        return this.subjectSoldes.asObservable();
    }
    getClickEventRefreshTableSoldesProp(): Observable<any> {
        return this.subjectSoldesProp.asObservable();
    }

    getClickEventRefreshTableArbitrage(): Observable<any> {
        return this.subjectArbitrage.asObservable();
    }

    getClickEventRefreshTableAnalyse(): Observable<any> {
        return this.subjectAnalyse.asObservable();
    }
    getClickEventRefreshTableEmbauche(): Observable<any> {
        return this.subjectEmbauche.asObservable();
    }

    getClickEventRefreshDashboard(): Observable<any> {
      return this.subjectDashboard.asObservable();
    }

    getClickEventRefreshAnnee(): Observable<any> {
      return this.subjectAnnee.asObservable();
    }

    getClickEventRefetchTableMonArbitrage(): Observable<any> {
        return this.subjectMonArbitrage.asObservable();
    }
  }
